import { render, staticRenderFns } from "./versionDetail.vue?vue&type=template&id=14b74dea&scoped=true"
import script from "./versionDetail.vue?vue&type=script&lang=js"
export * from "./versionDetail.vue?vue&type=script&lang=js"
import style0 from "./versionDetail.vue?vue&type=style&index=0&id=14b74dea&prod&scoped=true&lang=css"
import style1 from "./versionDetail.vue?vue&type=style&index=1&id=14b74dea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b74dea",
  null
  
)

export default component.exports